import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "flex flex-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        _createElementVNode("th", {
          class: _normalizeClass(_ctx.classes)
        }, _toDisplayString(_ctx.label), 3)
      ])
    ]),
    _createElementVNode("tbody", null, [
      _createElementVNode("tr", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
          return (_openBlock(), _createElementBlock("td", {
            key: index,
            class: "border px-8 py-4"
          }, [
            _renderSlot(_ctx.$slots, "default", { item: item })
          ]))
        }), 128))
      ])
    ])
  ]))
}